import { render, staticRenderFns } from "./CheckoutReviewItem.vue?vue&type=template&id=f948e998"
import script from "./CheckoutReviewItem.vue?vue&type=script&lang=js"
export * from "./CheckoutReviewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports